<template>
    <div class="container mt-5">

        <b-card
                title="Yeni Kamp Yeri Ekleme"
                tag="article"
                class="mb-2">


            <form ref="form" @submit.stop.prevent="handleSubmit">
                <b-form-group
                        label="Kamp İsmi"
                        label-for="kampIsmiInput">
                    <b-form-input
                            id="kampIsmiInput"
                            v-model="isim"
                            required
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                        label="Ülke"
                        label-for="ulke">
                    <b-form-input
                            id="ulke"
                            v-model="ulke"
                            required
                    ></b-form-input>
                </b-form-group>
                <b-button type="submit" class="btn-block" variant="success">Ekle</b-button>
            </form>
        </b-card>


    </div>
</template>

<script>
    import {YeniKampYeriEkle} from "@/api/kamp"

    export default {
        name: "yenikampyeriekle",
        data() {
            return {
                isim: '',
                ulke: '',
            }
        },
        methods: {
            async handleSubmit() {
                await YeniKampYeriEkle(this.isim, this.ulke)
                this.isim = ""
                this.ulke = ""
            }
        },
        created() {
            this.isim = this.$route.query.kampIsim
            console.log(this.$route.query.kampIsim)
        }
    }
</script>

<style scoped>

</style>
